import type {
  ObservationsMapParameterDisplayGroup,
  ParameterTimeSeriesConfiguration,
} from "@/lib/api";

export type TimeSeriesParameterEntry = {
  parameterId: string;
  label: string;
};

/** Unique parameters from time-series groups, in first-seen order. */
export function getTimeSeriesParameterEntries(
  configurations: ParameterTimeSeriesConfiguration[],
): TimeSeriesParameterEntry[] {
  const seen = new Set<string>();
  const entries: TimeSeriesParameterEntry[] = [];

  for (const config of configurations) {
    for (const series of config.series) {
      if (seen.has(series.parameter_id)) continue;
      seen.add(series.parameter_id);
      entries.push({ parameterId: series.parameter_id, label: series.label });
    }
  }

  return entries;
}

export function isDisplayGroupLabelOverridden(
  group: ObservationsMapParameterDisplayGroup,
): boolean {
  return Boolean(group.label_override?.trim());
}

export function deriveDisplayGroupLabelFromParameters(
  parameterIds: string[],
  timeSeriesEntries: TimeSeriesParameterEntry[],
  catalogLabel: (parameterId: string) => string | undefined,
): string {
  return parameterIds
    .map((parameterId) => {
      const entry = timeSeriesEntries.find((e) => e.parameterId === parameterId);
      if (entry?.label.trim()) return entry.label.trim();
      return catalogLabel(parameterId)?.trim() || parameterId;
    })
    .join(" | ");
}

export function resolveDisplayGroupLabel(
  group: ObservationsMapParameterDisplayGroup,
  timeSeriesEntries: TimeSeriesParameterEntry[],
  catalogLabel: (parameterId: string) => string | undefined,
): string {
  if (group.label_override?.trim()) return group.label_override.trim();
  return deriveDisplayGroupLabelFromParameters(
    group.parameter_ids,
    timeSeriesEntries,
    catalogLabel,
  );
}
